import Container from '@/components/Container';
import Lead from '@/components/Lead';
import SubHeading from '@/components/SubHeading';
import Card, { CardTitle, CardText } from '@/components/Card';
import Text from '@/components/Text';
import Image from '@/components/Image';
import Brand from '@/view/Brand';
import WorldMapCertifications from '@/domain/Testimonials/WorldMapCertifications';

export default function AboutUs() {
  return (
    <div className="overflow-hidden bg-white">
      <div className="relative min-h-screen overflow-hidden bg-gradient-to-t from-white via-green-100 to-white pb-10 lg:pb-20">
        <Container className="relative z-20">
          <div className="flex flex-col items-center py-10 lg:mx-auto lg:max-w-screen-lg lg:pt-20 lg:pb-32">
            <div className="flex flex-col items-center space-y-10 md:text-center lg:space-y-12 lg:px-10">
              <div className="flex flex-col space-y-2">
                <SubHeading heading="Nosotros" />
                <h1 className="text-4xl font-bold tracking-tight xl:text-5xl">
                  Entidad certificadora por excelencia preferida por
                  hispanohablantes
                </h1>
              </div>
              <Lead
                className="text-gray-700 lg:px-32 xl:text-xl xl:font-normal xl:leading-relaxed"
                muted={false}
              >
                Mediante la formación integral de su equipo, la evaluación y la
                certificación de sus habilidades, propiciamos la entrega
                periódica y continua de valor de sus productos y servicios.
              </Lead>
            </div>
          </div>
        </Container>
        <div className="relative z-10 pb-10">
          <Container maxWidth="max-w-screen-lg">
            <div className="aspect-w-16 aspect-h-9 relative overflow-hidden rounded-xl shadow-xl md:-skew-y-6 md:transform xl:shadow-2xl bg-white">
              <div
                className="absolute inset-0 scale-125 transform bg-cover bg-center bg-no-repeat md:skew-y-6"
                style={{
                  backgroundImage:
                    'url(https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy/v1610683320/nosotros/acerca-de-aibes_kxyiy9.jpg)',
                }}
              />
            </div>
          </Container>
        </div>
        <div className="pointer-events-none absolute inset-0 z-0 hidden w-full flex-col items-start overflow-hidden md:flex">
          <div className="absolute top-0 left-0 mt-20 w-2/6 -skew-y-6 transform lg:mt-96 xl:-ml-20 xl:w-3/6">
            <div className="h-40 w-2/4 bg-gradient-to-r from-green-200 to-transparent" />
            <div className="h-40 w-2/3 bg-gradient-to-r from-green-300 to-transparent" />
            <div className="h-40 w-5/6 bg-gradient-to-r from-green-400 to-transparent" />
          </div>
          <div className="absolute bottom-0 right-0 mt-20 flex w-2/6 -skew-y-6 transform flex-col items-end lg:mt-96 xl:-mr-20 xl:w-3/6">
            <div className="h-40 w-5/6 bg-gradient-to-l from-green-200 to-transparent" />
            <div className="h-40 w-2/3 bg-gradient-to-l from-green-300 to-transparent" />
            <div className="h-40 w-2/4 bg-gradient-to-l from-green-400 to-transparent" />
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-t from-green-100 to-white">
        <Container
          maxWidth="max-w-screen-lg"
          className="pb-10 lg:pb-20 xl:pt-16"
        >
          <div className="lg:text-center">
            <h2 className="mb-4 text-2xl font-semibold tracking-tight lg:mb-8 lg:px-10 lg:text-4xl">
              Con formación, entrenamiento y consultoría, ayudamos a personas y
              a empresas a entregar mayor valor en sus productos y servicios
            </h2>
            <Text
              muted
              className="text-cool-gray-700 text-lg font-normal lg:text-xl"
            >
              Nuestras soluciones de acompañamiento, capacitación y
              entrenamiento permiten a profesionales, organizaciones e
              instituciones, lograr la adopción de una cultura ágil.
            </Text>
          </div>
        </Container>
        <WorldMapCertifications />
      </div>
      <div className="relative z-10 hidden py-10 md:block lg:py-20">
        <div className="absolute left-0 right-0 top-0 -mt-20 flex h-40 justify-center">
          <div className="relative h-40 w-40 rounded-full shadow-xl">
            <div className="absolute top-1/2 left-1/2 h-32 w-32 -translate-y-1/2 -translate-x-1/2 transform">
              <span className="absolute z-0 inline-flex h-32 w-32 animate-ping-slow rounded-full border-2 border-green-500 opacity-75" />
              <span className="absolute z-0 inline-flex h-32 w-32 animate-ping-slow-offset rounded-full border-2 border-green-500 opacity-75" />
              <span className="absolute z-0 inline-flex h-32 w-32 animate-ping-slow-offset-2x rounded-full border-2 border-green-500 opacity-75" />
            </div>
            <div className="relative z-20 flex h-40 w-40 items-center justify-center rounded-full bg-white">
              <Brand hideName noLink logoSize="lg" />
            </div>
          </div>
        </div>
      </div>
      <div className="relative space-y-10 bg-white py-10 lg:py-20">
        <Container maxWidth="max-w-screen-lg" className="relative z-10">
          <div className="text-left md:text-center">
            <SubHeading heading="Nuestra misión" />
            <div className="space-y-4 lg:space-y-6">
              <h3 className="text-3xl font-bold tracking-tight lg:text-4xl">
                Certificar profesionales de excelencia
              </h3>
              <Text
                muted
                className="text-cool-gray-700 mx-auto max-w-screen-md text-lg font-normal leading-7"
              >
                Formar, entrenar, acompañar y certificar a profesionales;
                validando sus habilidades y competencias a través de
                certificaciones reconocidas internacionalmente.
              </Text>
            </div>
          </div>
        </Container>
      </div>
      <div className="relative space-y-10 bg-gradient-to-b from-gray-100 to-white py-10 lg:space-y-20 lg:py-20">
        <Container maxWidth="max-w-screen-lg" className="relative z-10">
          <div className="text-left md:text-center">
            <SubHeading heading="Nuestra visión" />
            <div className="space-y-4 lg:space-y-6">
              <h3 className="text-3xl font-bold tracking-tight lg:text-4xl">
                Entidad certificadora de excelencia preferida por
                hispanohablantes
              </h3>
              <Text
                muted
                className="text-cool-gray-700 mx-auto max-w-screen-md text-lg font-normal leading-7"
              >
                Ser reconocidos internacionalmente como la entidad certificadora
                de excelencia por nuestros métodos innovadores, soluciones,
                productos y servicios.
              </Text>
            </div>
          </div>
        </Container>
        <Container maxWidth="max-w-screen-lg">
          <ul className="grid list-none grid-cols-1 space-y-2 space-y-10 text-left md:space-y-0 lg:grid-cols-3 lg:gap-10 lg:space-y-0">
            <li className="flex flex-col space-y-4">
              <svg
                className="h-12 w-12"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 100 100"
                fill="none"
              >
                <rect
                  className="fill-current text-green-200"
                  width="100"
                  height="100"
                  rx="25"
                  ry="25"
                />
                <path
                  className="fill-current text-white"
                  d="M62 75.02586V68c0-8.21457 12-14.54 12-26.6153C74 27.9174 63.25483 17 50 17S26 27.9174 26 41.3847C26 53.4321 38.00582 59.83342 38 68c-.00106 1.47941 0 7.1122 0 7.1122l24-.08634z"
                />
                <path
                  className="fill-current text-green-500"
                  d="M62 70v6c0 4.08985-2.79726 7-6 7H44c-3.21336 0-6-2.91745-6-7v-6h24zm-2.21157-27.88626c.49395.99486.09352 2.2046-.8944 2.70203l-6.97411 3.51158v14.75148C51.91992 64.13086 51.06034 65 50 65c-1.06773 0-1.91992-.86014-1.91992-1.92117V48.32735l-6.97412-3.51158c-.98791-.49743-1.38834-1.70717-.89439-2.70203.49396-.99486 1.69525-1.3981 2.68317-.90068L50 44.79067l7.10526-3.5776c.98792-.49744 2.1892-.0942 2.68317.90067z"
                />
              </svg>
              <div className="text-lg">
                Por nuestros&nbsp;
                <b className="font-semibold">métodos innovadores</b>,
                soluciones, productos y servicios.
              </div>
            </li>
            <li className="flex flex-col space-y-4">
              <svg
                className="h-12 w-12"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 100 100"
                fill="none"
              >
                <rect
                  className="fill-current text-green-200"
                  width="100"
                  height="100"
                  rx="25"
                  ry="25"
                />
                <path
                  className="fill-current text-white"
                  d="M50 52c15.5828 0 23.8992 7.6071 24.9491 16.8213l.0509.5166v4.0966c0 1.1312-1.0175 2.0483-2.2727 2.0483H27.2727c-1.2552 0-2.2727-.917-2.2727-2.0483v-4.0966l.0509-.5166C26.1008 59.607 34.4172 52 50 52z"
                  fillRule="nonzero"
                />
                <path
                  className="fill-current text-green-400"
                  d="M50 20c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14z"
                />
              </svg>
              <div className="text-lg">
                Por la&nbsp;
                <b className="font-semibold">calidad humana y profesional</b>
                &nbsp;de nuestro equipo de entrenadores reconocidos como
                referentes en la región.
              </div>
            </li>
            <li className="flex flex-col space-y-4">
              <svg
                className="h-12 w-12"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 100 100"
                fill="none"
              >
                <rect
                  className="fill-current text-green-200"
                  width="100"
                  height="100"
                  rx="25"
                  ry="25"
                />
                <path
                  className="fill-current text-green-400"
                  d="M50.1184 54.29527L32.79666 65.3182C32.92952 65.85694 33 66.42024 33 67c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7c1.83997 0 3.51414.7099 4.76354 1.87076l15.84162-10.08103L31.0222 38.91685C29.8405 39.6055 28.46632 40 27 40c-4.41828 0-8-3.58172-8-8s3.58172-8 8-8 8 3.58172 8 8c0 1.49355-.40928 2.8915-1.1218 4.08782l15.30564 12.6438 11.06541-18.87628C58.86117 28.4942 58 26.59767 58 24.5c0-4.14214 3.35786-7.5 7.5-7.5 4.14214 0 7.5 3.35786 7.5 7.5 0 4.14214-3.35786 7.5-7.5 7.5-.6029 0-1.18917-.07114-1.7509-.20547L52.4865 51.00719l18.79552 9.39775C72.7343 58.92095 74.7596 58 77 58c4.41828 0 8 3.58172 8 8s-3.58172 8-8 8-8-3.58172-8-8c0-.73457.099-1.44602.2844-2.12173l-19.166-9.583zM50 83c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6 6 2.6863 6 6-2.6863 6-6 6z"
                />
                <circle
                  className="fill-current text-white"
                  cx="50"
                  cy="50"
                  r="13"
                />
              </svg>
              <div className="text-lg">
                Por nuestra&nbsp;
                <b className="font-semibold">contribución a la comunidad</b>
                &nbsp;hispanohablante.
              </div>
            </li>
          </ul>
        </Container>
      </div>
      <div className="relative -mx-32 flex select-none justify-center md:mx-0 lg:-mt-20 lg:-mb-20 lg:-mr-20">
        <Image
          src="nosotros/acerca-de-aibes-bottom.jpg"
          className="pointer-events-none mx-auto h-auto w-5/6 max-w-full select-none"
          alt="Acerca de AIBES"
        />
      </div>
      <div className="relative pb-10 lg:pb-20">
        <Container className="relative z-30 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="flex lg:col-span-6">
            <Card icon="users" link="/entrenadores">
              <CardTitle>Nuestros entrenadores</CardTitle>
              <CardText>
                Están preparados para enseñar y acompañar a los equipos en la
                adopción de desarrollo ágil de productos.
              </CardText>
            </Card>
          </div>
          <div className="flex lg:col-span-6">
            <Card icon="envelope" link="/contacto">
              <CardTitle>Mantengamos el contacto</CardTitle>
              <CardText>
                Estamos aquí para ayudarte en tus procesos de adopción de una
                cultura ágil y responder tus preguntas.
              </CardText>
            </Card>
          </div>
        </Container>
        <div
          className="absolute inset-0 -skew-y-6 transform bg-green-500 bg-gradient-to-tr from-green-500 to-green-400 shadow-outside-light-xl lg:mt-10"
          style={{ height: '200%' }}
        />
      </div>
    </div>
  );
}
